import { RefObject } from "react";
import Button from "../common/Button";
import ListDetailModal from "../common/ListDetailModal";
import CaseDetailView from "../Cases/CaseDetailView";
import CasesList, { CaseListItem } from "../Cases/CasesList";

// "Fill from a case": a list of cases (tick one), or click a case to read it
// first, then fill the form with its narrative and recordings.
const CaseFillPickerModal: React.FC<{
  modalRef: RefObject<HTMLDialogElement>;
  onFill: (caseId: string) => void;
}> = ({ modalRef, onFill }) => {
  const fill = (caseId: string) => {
    modalRef.current?.close();
    onFill(caseId);
  };

  return (
    <ListDetailModal<CaseListItem>
      modalRef={modalRef}
      title="Fill form from a case"
      renderList={(open) => (
        <CasesList picker={{ confirmLabel: "Fill form with case details", onConfirm: (c) => fill(c.id), onOpenCase: open }} />
      )}
      renderDetail={(item, back) => (
        <CaseDetailView
          caseId={item.id}
          onBack={back}
          actions={({ blocked }) => (
            <Button variant="primary" size="sm" disabled={!!blocked} title={blocked} onClick={() => fill(item.id)}>
              Fill form with this case
            </Button>
          )}
        />
      )}
    />
  );
};

export default CaseFillPickerModal;
